import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { BIASSE_INIT } from '../constants/globals';
import CSVDownload from './csvDownload';
import ExcelStyledExport from './excelStyledExport.js';

const LesCommandesTab = (props) => {
    const { userCJ } = useSelector(state => state);
    const userNum = userCJ.uNum;
    const userProducteur = userCJ.uProducteur;
    const userCommission = userCJ.uCommission;
    const userAdmin = userCJ.uAdmin;

    const [biasse, setBiasse] = useState([]);
    const [cdesLignes, setCdesLignes] = useState([]);
    const [filtre, setFiltre] = useState({
        filtreMonoAdherent: 0,    // 0 : tous les utilisateurs ou le num de l'utilisateur filtré
        filtreMonoProducteur: 0,  // 0 : tous les producteurs ou le num du producteur filtré
    });

    const { postId } = useParams();
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        const newFiltre = {
            filtreMonoAdherent: 0,
            filtreMonoProducteur: 0,
        }
        if (!userAdmin && !userProducteur) { newFiltre.filtreMonoAdherent = userNum } // ne voir que son propre panier si uniquement adherent
        if (userProducteur) { newFiltre.filtreMonoProducteur = userNum } // ne voir que les commandes qui lui sont destinées si uniquement producteur            
        // recuperation de la biasse active
        fetch(`${URL_COURTJUS_BACK}/biasseactive`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res === null) {
                    const newBiasse = BIASSE_INIT;
                    newBiasse.cmdOpen = false
                    setBiasse(newBiasse);
                } else {
                    newFiltre.filtreBiasse = res.bNum;
                    const dateNow = new Date();
                    const dateB = new Date(res.bDate.substring(0, 10));
                    const dateBCI = new Date(res.bDateCdeIni.substring(0, 10));
                    const dateBCE = new Date(res.bDateCdeEnd.substring(0, 10));
                    if (dateBCI <= dateNow && dateBCE >= dateNow) { res.cmdOpen = true } else { res.cmdOpen = false };
                    res.bDate = dateB.toLocaleDateString();
                    res.bDateCdeIni = dateBCI.toLocaleDateString();
                    res.bDateCdeEnd = dateBCE.toLocaleDateString();
                    setBiasse(res);
                    // recuperation des commandes de la biasses
                    fetch(`${URL_COURTJUS_BACK}/cdes/${newFiltre.filtreMonoAdherent}_${newFiltre.filtreMonoProducteur}_${res.bNum}`, {
                        method: 'GET',
                        headers: headers,
                    })
                        .then(response => response.json())
                        .then(resC => {
                            let tables = createPivotTables(resC)
                            setCdesLignes(tables);
                        });
                }
            });
    }, []);

    function createPivotTables(rows) {
        let buyers = [...new Set(rows.map(row => row.acheteur))];
        let producers = [...new Set(rows.map(row => row.Producteur))];

        let tables = {};

        for (let producer of producers) {
            let articles = [...new Set(rows.filter(row => row.Producteur === producer).map(row => row.article))];
            let table = Array(buyers.length).fill().map(() => Array(articles.length).fill(0));

            for (let row of rows) {
                if (row.Producteur === producer && Number(row.cNombre) > 0) {
                    let buyerIndex = buyers.indexOf(row.acheteur);
                    let articleIndex = articles.indexOf(row.article);
                    let prix = parseFloat(row.cPrixT)
                    let prixFormate = prix.toFixed(2) + ' €';
                    let nb = Math.round(row.cNombre * 100) / 100
                    if (row.article !== 'Total') {
                        table[buyerIndex][articleIndex] = nb + " (" + prixFormate + ")";
                        if (row.cCommentaire.length > 0) { table[buyerIndex][articleIndex] += ' [' + row.cCommentaire + ']' }
                    } else {
                        table[buyerIndex][articleIndex] = prixFormate;
                    }
                }
            }

            tables[producer] = { table, articles };
        }

        return { tables, buyers, producers };
    }

    function Table({ data, headers }) {
        return (
            <table className="table table-bordered table-sm small">
                <thead>
                    <tr className="table-info">
                        {headers.map(header => (
                            <th key={header} className={"small cdes-tab-head"}><div className={"cdes-tab-head-div"}>{header}</div></th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, i) => {
                        // Vérifiez si toutes les cellules de la ligne à partir de la deuxième cellule ont une valeur de 0
                        const allCellsAfterFirstAreZero = row.slice(1).every(cell => cell === 0);

                        // Si toutes les cellules après la première ne sont pas égales à 0, créez la ligne
                        if (!allCellsAfterFirstAreZero) {
                            return (
                                <tr key={i} className={"table-light"}>
                                    {row.map((cell, j) => (
                                        <td key={j} className={j > 0 ? "small col-1" : undefined}>{cell != 0 && cell}</td>
                                    ))}
                                </tr>
                            );
                        }

                        // Si toutes les cellules après la première sont égales à 0, ne créez pas la ligne
                        return null;
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            <section className="nav-admin">
            </section>
            <section className="nav-admin">
            </section>
            <section className='main-title'><p>Commandes pour le {biasse.bDate} - {biasse.bLibelle} {biasse.cmdOpen}
                {/* <span className="section-prods-err no-print">{!biasse.cmdOpen && ` ( Commandes fermées ) `}</span> */}
                {/* <span className="p-impact">{` commandes entre le ${biasse.bDateCdeIni} et le ${biasse.bDateCdeEnd}`}</span> */}
            </p>
            </section>
            {userCJ.uNum > 0 &&
                <section className="section-cdes">

                    <div>
                        {cdesLignes.producers && cdesLignes.producers.map(producer => {
                            let { table, articles } = cdesLignes.tables[producer];
                            return (
                                <div key={producer}>
                                    <h2>
                                        <CSVDownload headers={['', ...articles]} filename="commandes_court-jus.csv" data={table.map((row, i) => [cdesLignes.buyers[i], ...row])} delimiter=";" />
                                        <ExcelStyledExport
                                            headers={['Acheteur', ...articles]}
                                            filename="commandes_court-jus.xlsx"
                                            data={table.map((row, i) => [cdesLignes.buyers[i], ...row])}
                                        />
                                        {producer}
                                    </h2>
                                    <Table data={table.map((row, i) => [cdesLignes.buyers[i], ...row])} headers={['', ...articles]} />
                                </div>
                            );
                        })}
                    </div>
                </section>
            }
            {userCJ.uNum < 1 && <section className="section-prods-err"><p>Veuillez vous authentifier !</p></section>}
            <div className="main-down"></div>

        </main>

    )
}

export default LesCommandesTab;